var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('YtLoadingBar',{attrs:{"progress":_vm.$store.state.system.progressBar.progress,"on-error-done":_vm.onErrorDone,"on-progress-done":_vm.onProgressDone,"error":_vm.$store.state.system.progressBar.error,"direction":"right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }